<template>
  <!-- //NOSONAR -->
  <li :class="{ active: active }">
    <megamenuoverlay></megamenuoverlay>
    <div class="navigation-container-button" @click="activate()">
      <slot name="itemnavigation">item navigation</slot>
    </div>
    <div
      ref="megamenuRef"
      class="menu-item level-two mega-menu"
      :class="{ active: active }"
      :aria-hidden="ariaHidden"
    >
      <slot name="megamenublock">megamenu block</slot>
    </div>
  </li>
</template>

<script>
export default {
  name: 'itemnavigation',
  props: {
    haspopup: { type: Boolean },
  },
  data() {
    return {
      active: false,
      ariaHidden: 'true',
    };
  },
  mounted() {
    // NOSONAR
    const elems = document.querySelectorAll('.block-with-img img');
    Array.prototype.forEach.call(elems, (el) => {
      if (el.classList.contains('lazyloaded')) {
        el.classList.remove('lazyloaded');
        el.classList.remove('lazyaspectratio');
      } else {
        el.classList.remove('lazyload');
        el.classList.remove('lazyaspectratio');
      }
    });
    if (window.eventBus) {
      /* istanbul ignore next */
      window.eventBus.$on('update.itemnavigation', () => {
        this.active = false;
        this.ariaHidden = 'true';

        setTimeout(() => {
          const linkNavigation = document.querySelectorAll('.dropdown-toggle');
          if (linkNavigation) {
            Array.prototype.map.call(linkNavigation, (obj) => {
              obj.setAttribute('aria-expanded', false);
            });
          }
          const linkNavigationActive = document.querySelectorAll('li.active .dropdown-toggle');
          if (linkNavigationActive) {
            const loadMenu = document.querySelectorAll('.menu-item.active img');
            Array.prototype.forEach.call(loadMenu, (el) => {
              if (!el.classList.contains('lazyloaded')) {
                el.classList.add('lazyload');
              }
            });
            window.eventBus.$once('images.lazybeforeunveil', () => {
              Array.prototype.map.call(linkNavigationActive, (obj) => {
                obj.setAttribute('aria-expanded', true);
              });
            });
          }
        }, 100);
      });
      /* istanbul ignore next */
      window.eventBus.$on('set.scrollMegamenu', () => {
        setTimeout(() => {
          this.setHeightForSmallScreens();
        }, 500);
      });
    }
  },
  methods: {
    activate() {
      const searchItemActive = document.querySelector('.main-menu-search section');

      if (searchItemActive) {
        document.querySelector('.main-menu-search section').style.visibility = 'hidden';
      }

      const cookieBanner = document.querySelector('.cookie-banner');

      if (cookieBanner) {
        const megamenuOverlay = document.querySelectorAll('.megamenu-overlay');

        Array.prototype.map.call(megamenuOverlay, (obj) => {
          obj.style.marginTop = `${cookieBanner.offsetHeight + 200}px`;
        });
      }

      if (this.active) {
        this.active = false;
        this.ariaHidden = 'true';
        document.querySelector('body').classList.remove('no-scroll');
        this.resetHeightForSmallScreens();
      } else {
        if (window.eventBus) {
          window.eventBus.$emit('update.itemnavigation', false);
          window.eventBus.$emit('update.itemmegamenu', false);
          window.eventBus.$emit('show.megamenuoverlay', true);
          this.resetHeightForSmallScreens();
        }
        if (!this.active && this.haspopup) {
          this.active = true;
          this.ariaHidden = 'false';
          //document.querySelector('body').classList.add('no-scroll')
          this.resetHeightForSmallScreens();

          /* istanbul ignore next */
          if (
            window.ScreenSizeHandler &&
            window.ScreenSizeHandler.getMqForSize('large').selected === true
          ) {
            window.eventBus.$emit('set.scrollMegamenu', false);
          }
        }
      }
    },
    /* istanbul ignore next */
    setHeightForSmallScreens() {
      const megaMenuActive = document.querySelector('.active .mega-menu-item');
      const offsetTop = this.$refs.megamenuRef.getBoundingClientRect().top + window.pageYOffset;
      const computerStyle = window.getComputedStyle(this.$refs.megamenuRef);
      const height = megaMenuActive ? megaMenuActive.offsetHeight : 0;
      const padding =
        parseInt(computerStyle.paddingTop, 10) + parseInt(computerStyle.paddingBottom, 10);
      const winHeight = window.innerHeight;

      if (height + padding > winHeight) {
        megaMenuActive.style.height = `${winHeight - offsetTop}px`;
        megaMenuActive.style.overflow = 'auto';
      }
    },

    /* istanbul ignore next */
    resetHeightForSmallScreens() {
      if (document.querySelector('.mega-menu-item')) {
        const els = document.querySelectorAll('.mega-menu-item');
        Array.prototype.map.call(els, (obj) => {
          obj.removeAttribute('style');
          obj.style.display = 'auto';
        });
      }
    },
  },
};
</script>
